import { Box, Divider, Grid, Stack, styled, Typography } from "@mui/material";
import { LoadingSpinner } from "../../components/shared/LoadingSpinner";
import { formatCurrency, formatPercentage } from "../../utils/formatters";
import { toTitleCase } from "../../utils/toTitleCase";
import { useData } from "../../utils/useData";

const FeesTitle = styled(Typography)({
  fontWeight: 600,
  fontSize: 16,
  marginTop: 30
});

const AccountDetailsDisplay = styled(Box)({
  backgroundColor: "rgba(2, 176, 125, 0.1)",
  borderRadius: 12,
  overflow: "hidden",
  border: "2px solid #E4E7EC",
  marginTop: 24,
  paddingTop: 18,
  paddingLeft: 24,
  paddingRight: 24,
  paddingBottom: 18,
  whiteSpace: "nowrap",
  overflowX: "auto"
});

const AccountDetailsDisplayTitle = styled(Typography)({
  fontWeight: 800,
  fontSize: 14,
  paddingBottom: 12
});

const AccountDetailsRowTitle = styled(Box)({
  color: "#5C5C5C",
  fontSize: 14,
  marginRight: 8
});

const AccountDetailsRowInfo = styled(Box)({
  color: "#454545",
  fontWeight: 600,
  fontSize: 14
});

const Fees = () => {
  const { employer, employerModules } = useData();

  if (employer.isIdle || employer.isLoading) return <LoadingSpinner />;

  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={8}>
        <AccountDetailsDisplay>
          <AccountDetailsDisplayTitle>Card</AccountDetailsDisplayTitle>
          <Divider
            sx={{ borderColor: "#D3D3D3", paddingLeft: 12, paddingRight: 12 }}
          />
          <Box sx={{ paddingTop: "12px" }}>
            {employer.data?.paymentOptions.physicalIssuedCardFee !==
            undefined ? (
              <Stack direction={"row"} justifyContent={"space-between"}>
                <AccountDetailsRowTitle>
                  Physical Issuance Fee (per card):
                </AccountDetailsRowTitle>
                <AccountDetailsRowInfo>
                  {employer.data?.country.currencyName}
                  {formatCurrency(
                    employer.data.paymentOptions.physicalIssuedCardFee,
                    2
                  )}
                </AccountDetailsRowInfo>
              </Stack>
            ) : null}
          </Box>
          <Box sx={{ paddingTop: "12px" }}>
            {employer.data?.paymentOptions.physicalRenewCardFee !==
            undefined ? (
              <Stack direction={"row"} justifyContent={"space-between"}>
                <AccountDetailsRowTitle>
                  Physical Reissuance Fee (per card):
                </AccountDetailsRowTitle>
                <AccountDetailsRowInfo>
                  {employer.data?.country.currencyName}
                  {formatCurrency(
                    employer.data.paymentOptions.physicalRenewCardFee,
                    2
                  )}
                </AccountDetailsRowInfo>
              </Stack>
            ) : null}
          </Box>
          <Box sx={{ paddingTop: "12px" }}>
            {employer.data?.paymentOptions.digitalIssuedCardFee !==
            undefined ? (
              <Stack direction={"row"} justifyContent={"space-between"}>
                <AccountDetailsRowTitle>
                  Digital Issuance Fee (per card):
                </AccountDetailsRowTitle>
                <AccountDetailsRowInfo>
                  {employer.data?.country.currencyName}
                  {formatCurrency(
                    employer.data.paymentOptions.digitalIssuedCardFee,
                    2
                  )}
                </AccountDetailsRowInfo>
              </Stack>
            ) : null}
          </Box>
          <Box sx={{ paddingTop: "12px" }}>
            {employer.data?.paymentOptions.digitalRenewCardFee !== undefined ? (
              <Stack direction={"row"} justifyContent={"space-between"}>
                <AccountDetailsRowTitle>
                  Digital Reissuance Fee (per card):
                </AccountDetailsRowTitle>
                <AccountDetailsRowInfo>
                  {employer.data?.country.currencyName}
                  {formatCurrency(
                    employer.data.paymentOptions.digitalRenewCardFee,
                    2
                  )}
                </AccountDetailsRowInfo>
              </Stack>
            ) : null}
          </Box>
        </AccountDetailsDisplay>

        <FeesTitle>Modules</FeesTitle>

        {employerModules.data?.map((module) => {
          return (
            <AccountDetailsDisplay>
              <AccountDetailsDisplayTitle>
                {toTitleCase(module.employerModuleType)}
              </AccountDetailsDisplayTitle>
              <Divider
                sx={{
                  borderColor: "#D3D3D3",
                  paddingLeft: 12,
                  paddingRight: 12
                }}
              />
              <Box sx={{ paddingTop: "12px" }}>
                  <Stack direction={"row"} justifyContent={"space-between"}>
                    <AccountDetailsRowTitle>Load Fee</AccountDetailsRowTitle>
                    <AccountDetailsRowInfo>
                      {formatPercentage(
                        module.employerModuleConfig.loadFeePercent
                      )}
                    </AccountDetailsRowInfo>
                  </Stack>
              </Box>
              <Box sx={{ paddingTop: "12px" }}>
                  <Stack direction={"row"} justifyContent={"space-between"}>
                    <AccountDetailsRowTitle>
                      Module Fee (per user):
                    </AccountDetailsRowTitle>
                    <AccountDetailsRowInfo>
                      {employer.data?.country.currencyName}
                      {formatCurrency(
                        module.employerModuleConfig.monthlyUserFee,
                        2
                      )}
                    </AccountDetailsRowInfo>
                  </Stack>
              </Box>
              <Box sx={{ paddingTop: "12px" }}>
                  <Stack direction={"row"} justifyContent={"space-between"}>
                    <AccountDetailsRowTitle>
                      Min. Coverage
                    </AccountDetailsRowTitle>
                    <AccountDetailsRowInfo>
                      {formatPercentage(
                        module.employerModuleConfig
                          .fundCoverageRequirementPercent
                      )}
                    </AccountDetailsRowInfo>
                  </Stack>
              </Box>
            </AccountDetailsDisplay>
          );
        })}
      </Grid>
    </Grid>
  );
};

export { Fees };
